/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 10/15/2019
 *
 */

import React from 'react';
import './sidebar.css';
import SidebarContent from './sidebarContent';
import logo from "../../../assets/img/pearson_logo_large.png";
import Icon from "../../generic/icon/Icon";

/** functional component for Sidebar **/
const Sidebar = () => {
    // initialize the main icons in header
    const mainIcons = [];

    // push home icon
    mainIcons.push(
        <a key={'Home'} href={process.env.REACT_APP_BASE_URL + "/#/home/"} aria-label="Home logo">
            <i title="Home" className="fa fa-lg fa-home"/>
        </a>
    );
    // push sign out icon
    mainIcons.push(
        <a key={'Sign Out'} href={process.env.REACT_APP_BASE_URL + "/"} onClick={() => {localStorage.removeItem('tmcUser')}} aria-label="Sign Out logo" >
            <i title="Sign Out" className="fa fa-lg fa-sign-out"/>
        </a>
    );

    // close side bar
    const closeSideBar = () => {
        document.getElementById('sidebar-container').style.display = 'none';
    };

    // open side bar
    const openSideBar = () => {
        document.getElementById('sidebar-container').style.display = 'inline-block';
    };

    return(
        <div id="sidebar" >
            <div id="sidebar-bar-icon" style={{cursor: 'pointer'}}
                 onClick={() => openSideBar()} className="sidebar-bar-icon">
                <i title="SideBar Icon" className="fa fa-lg fa-bars"/>
            </div>
            <div id="sidebar-container" className="sidebar-container">
                <nav className="sidebar-nav">
                    <div className="sidebar-scrollbar" id="style-1">
                        <div className="sidebar-header-logo">
                            <button className="pe-icon--btn static-close-title"
                                    onClick={() => closeSideBar()}
                                    aria-label="Close warning">
                                <Icon name="remove-sm-24"/>
                            </button>
                            <div className="sidebar-pearson-logo-container">
                                <a href="https://www.pearson.com/us/" aria-label="Pearson logo"
                                   rel="noopener noreferrer"  target="_blank">
                                    <img src={logo} height="37px" alt="Pearson Logo" />
                                </a>
                            </div>
                            <div className="sidebar-header-icons">
                                {mainIcons}
                            </div>
                        </div>
                        <SidebarContent/>
                    </div>
                </nav>
            </div>
        </div>
    )
};

export default Sidebar;
